import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  getParts as getPartsPagedEndpoint,
  getPart as getPartEndpoint,
  addPart as addPartEndpoint,
  updatePart as updatePartEndpoint,
  addPartImages as addPartImagesEndpoint,
  publishPart as publishPartEndpoint,
  publish as publishEndpoint
} from "../../helpers/fakebackend_helper";

export const publish = createAsyncThunk("part/publish", async (request) => {
  try {
    return publishEndpoint(request);
  } catch(error) {
    return error;
  }
});

export const getPartsPaged = createAsyncThunk("part/getPartsPaged", async (paginationRequest) => {
  try {
    return getPartsPagedEndpoint(paginationRequest);
  } catch (error) {
    return error;
  }
});

export const getPart = createAsyncThunk("part/getPart", async (partId) => {
  try {
    return getPartEndpoint(partId);
  } catch (error) {
    return error;
  }
});

export const addPart = createAsyncThunk("part/addPart", async (part) => {
  try {
    const data = await addPartEndpoint(part);
    toast.success("Dio uspješno dodan", { autoClose: 3000 });
    return data;
  } catch (error) {
      toast.error("Dodavanje dijela neuspješno.", { autoClose: 3000 });
    return error;
  }
});

export const updatePart = createAsyncThunk("part/updatePart", async (part) => {
  try { 
    const data = await updatePartEndpoint(part);
    toast.success("Dio uspješno ažuriran", { autoClose: 3000 });
    return data;
  }
  catch (error) {
      toast.error("Ažuriranje dijela neuspješno.", { autoClose: 3000 });
      return error;
  }
});
export const addPartImages = createAsyncThunk("part/addPartImages", async (images) => {
  try {
    const data = await addPartImagesEndpoint(images);
    toast.success("Slike uspješno ažurirane", { autoClose: 3000 });
    return data;
  } catch (error) {
    toast.error("Dodavanje novih slika neuspješno.", { autoClose: 3000 });
    return error;
  }
});

/*
import {
  getAllParts as getAllPartsApi,
  getPart as getPartApi, 
  addPart as addPartApi,
  addPartWithAttributes as addPartWithAttributesApi,
  updatePart as updatePartApi, 
  updatePartImages as updatePartImagesApi,
  getPartsPaged as getPartsPagedApi,
  getSearchResults as getSearchResultsApi
} from "../../helpers/fakebackend_helper";


export const getAllParts = createAsyncThunk("part/getAllParts", async () => {
  try {
    const response = getAllPartsApi();
    return response;
  } catch (error) {
    return error;
  }
});
export const getPartsPaged = createAsyncThunk("part/getPartsPaged", async (request) => {
  try {
    const response = getPartsPagedApi(request);
    return response;
  } catch (error) {
    return error;
  }
});
export const getSearchResults = createAsyncThunk("part/getSearchResults", async (request) => {
  try {
    const response = getSearchResultsApi(request);
    return response;
  } catch (error) {
    return error;
  }
});
export const getPart = createAsyncThunk("part/getPart", async (partId) => {
  try {
    const response = getPartApi(partId);
    return response;
  } catch (error) {
    return error;
  }
});

export const addPartWithAttributes = createAsyncThunk("part/addPartWithAttributes", async (part) => {
    try {
      const response = addPartWithAttributesApi(part);
      const data = await response;
      toast.success("Dio uspješno dodan", { autoClose: 3000 });
      return data;
    } catch (error) {
      toast.error("Dodavanje dijela neuspješno.", { autoClose: 3000 });
      return error;
    }
  });
  export const addPart = createAsyncThunk("part/addPart", async (part) => {
    try {
      const response = addPartApi(part);
      const data = await response;
      toast.success("Dio uspješno dodan", { autoClose: 3000 });
      return data;
    } catch (error) {
      toast.error("Dodavanje dijela neuspješno.", { autoClose: 3000 });
      return error;
    }
  });



*/